//文章
const toolBox = () => import('@/components/tool/toolBox');
const toolList = () => import('@/components/tool/toolList');




// const music                 = () => import('@/components/tool/tool/music');

const styleLibrary = () => import('@/components/tool/tool/styleLibrary');
const addStyleCode = () => import('@/components/tool/tool/styleLibrary/addStyleCode');
const styleLibraryCategory = () => import('@/components/tool/tool/styleLibrary/category/styleLibraryCategory');

const translate = () => import('@/components/tool/tool/translate');
const collectStudent = () => import('@/components/tool/tool/collect/student');
const mediaLibrary = () => import('@/components/tool/tool/mediaLibrary');
const book = () => import('@/components/tool/reader/book');
const bookChapter = () => import('@/components/tool/reader/bookChapter');
const cookbook = () => import('@/components/tool/cook/cookbook');

const elasticsearch = () => import('@/components/tool/elasticsearch');
const amap = () => import('@/components/tool/amap');
const websocket = () => import('@/components/tool/websocket');
// const ssh = () => import('@/components/tool/ssh');
const guidao = () => import('@/pages/guidao');



export default {
    path: '/toolBox',
    name: '/toolBox',
    component: toolBox,
    children: [
        { path: 'guidao', component: guidao, name: 'guidao' },
        { path: 'toolList', component: toolList, name: 'toolList' },
        // { path: 'music', component: music, name: 'music' }, 

        { path: 'styleLibrary', component: styleLibrary, name: 'styleLibrary' },
        { path: 'addStyleCode', component: addStyleCode, name: 'addStyleCode' },
        { path: 'styleLibraryCategory', component: styleLibraryCategory, name: 'styleLibraryCategory' },

        { path: 'translate', component: translate, name: 'translate' },
        { path: 'collectStudent', component: collectStudent, name: 'collectStudent' },
        { path: 'mediaLibrary', component: mediaLibrary, name: 'mediaLibrary' },
        { path: 'book', component: book, name: 'book' },
        { path: 'bookChapter', component: bookChapter, name: 'bookChapter' },
        { path: 'elasticsearch', component: elasticsearch, name: 'elasticsearch' },
        { path: 'amap', component: amap, name: 'amap' },
        { path: 'websocket', component: websocket, name: 'websocket' },
        { path: 'cookbook', component: cookbook, name: 'cookbook' },
        // { path: 'ssh', component: ssh, name: 'ssh' },
    ]
}



// WEBPACK FOOTER //
// ./src/router/routes/tool.js